import { IAppState } from '../../../../../AppModulesWrapper';

export const selectRecommendedPackagePolygonIds = (state: IAppState): number[] => {
  return state.servicePickerWidgetV2.recommendedPackages.checkoutModalData.polygonIds;
};
